import { createIcon } from './createIcon'

export const TruckingShipmentsIcon = createIcon({
  displayName: 'Trucking',
  viewBox: '0 0 20 19',
  path: [
    <path
      fill="currentColor"
      d="M8.75.75H.417A.417.417 0 000 1.167v9.583a.417.417 0 00.417.417h9.166A.417.417 0 0010 10.75V1.742A1.133 1.133 0 008.75.75zM7.5 3.667V8.25a.625.625 0 01-1.25 0V3.667a.625.625 0 011.25 0zm-3.75 0V8.25a.625.625 0 01-1.25 0V3.667a.625.625 0 011.25 0z"
    />,
    <path
      fill="currentColor"
      d="M16.85 2.967a.208.208 0 01-.125-.084L16.108 2C15 .333 12.2.333 12.083.333a.833.833 0 00-.833.834V12a.434.434 0 01-.433.433H.417a.416.416 0 00-.417.4v1.892a.2.2 0 00.108.183.2.2 0 00.217 0 2.442 2.442 0 011.342-.408 2.5 2.5 0 012.425 1.925.217.217 0 00.2.158h.583a.217.217 0 00.2-.158A2.5 2.5 0 017.5 14.5a2.501 2.501 0 012.117 1.192c.05.075.091.083.233.083h.983a.392.392 0 01.384.383.833.833 0 00.833.834h.217a.209.209 0 00.208-.192 2.5 2.5 0 015 0 .208.208 0 00.208.192h.65A1.667 1.667 0 0020 15.325V7a4.167 4.167 0 00-3.15-4.033zm1.667 6.308a.199.199 0 01-.106.203.2.2 0 01-.078.022h-2.291a.208.208 0 01-.209-.25V4.717a.19.19 0 01.067-.15.216.216 0 01.158-.067 2.7 2.7 0 012.5 2.5l-.041 2.275z"
    />,
    <path
      fill="currentColor"
      d="M1.667 18.667a1.667 1.667 0 100-3.334 1.667 1.667 0 000 3.334zM7.5 18.667a1.667 1.667 0 100-3.334 1.667 1.667 0 000 3.334zM15 18.667a1.667 1.667 0 100-3.334 1.667 1.667 0 000 3.334z"
    />,
  ],
})
